import { useEffect } from "react";

export const useInjectClickCaseScript = () => {
  useEffect(() => {
    // ccConVal = 150;
    const script = document.createElement("script");
    script.async = true;
    script.type = "text/javascript";
    script.src = "https://www.clickcease.com/monitor/cccontrack.js";
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
};
